import type { ReactNode } from 'react';
import type React from 'react';

import type { Breadcrumb } from '@xing-com/crate-people-directory-breadcrumbs';
import { Breadcrumbs } from '@xing-com/crate-people-directory-breadcrumbs';
import { LetterNavigation } from '@xing-com/crate-people-directory-letter-navigation';
import { MetaData } from '@xing-com/crate-people-directory-meta-data';
import { PageHeader } from '@xing-com/crate-people-directory-page-header';
import { usePeopleDirectoryPageView } from '@xing-com/crate-people-directory-tracking';
import { sanitizeUrl } from '@xing-com/crate-people-directory-utils';
import Grid, { Row, Column } from '@xing-com/xing-grid';

import { StyledContainer } from './page-layout.styles';

type PageLayoutProps = {
  letter?: string;
  seoUrl?: string;
  pageName: string;
  children: ReactNode;
  seoTitle?: string;
  seoDescription?: string;
  index?: boolean;
  breadcrumbs?: Breadcrumb[];
  hidePageHeader?: boolean;
  hideLetterNavigation?: boolean;
  pageHeaderAsSecondaryHeadline?: boolean;
};

export const PageLayout: React.FC<PageLayoutProps> = ({
  letter,
  seoTitle,
  seoDescription,
  pageName,
  seoUrl = 'http://www.xing.com',
  index,
  children,
  breadcrumbs,
  hidePageHeader,
  hideLetterNavigation,
  pageHeaderAsSecondaryHeadline,
}) => {
  usePeopleDirectoryPageView(pageName);

  return (
    <StyledContainer>
      <MetaData
        title={seoTitle}
        description={seoDescription}
        url={sanitizeUrl(seoUrl)}
        index={index}
      />
      <Grid type="standard" data-cy="people-directory">
        <Row>
          <Column size={12}>
            <Breadcrumbs items={breadcrumbs} />
          </Column>
        </Row>
        {!hidePageHeader && (
          <>
            <Row>
              <Column size={12}>
                <PageHeader
                  asSecondaryHeadline={pageHeaderAsSecondaryHeadline}
                />
              </Column>
            </Row>
            {!hideLetterNavigation && (
              <Row>
                <Column size={12}>
                  <LetterNavigation activeLetter={letter} />
                </Column>
              </Row>
            )}
          </>
        )}
        {children}
      </Grid>
    </StyledContainer>
  );
};
